import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const API_URL = process.env.REACT_APP_API_URL || "/api";
      const response = await axios.post(`${API_URL}/login`, { email, password });

      // Handle professional response format
      if (response.data.status === "success") {
        localStorage.setItem("isAuthenticated", "true");
        if (response.data.data && response.data.data.name) {
          localStorage.setItem("emonews-username", response.data.data.name);
        }
        history.push("/overview");
      } else {
        alert(response.data.message || "Invalid Credentials");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Login Failed";
      alert(errorMsg);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box animate-fade-in">
        <div className="login-logo">
          <img src="/emonews-logo.png" alt="EmoNews" className="login-logo-img" />
        </div>
        <h2 className="login-title">Welcome Back</h2>
        <p className="login-subtitle">Sign in to continue to EmoNews</p>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label htmlFor="login-email">Email Address</label>
            <input
              id="login-email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-field"
              autoComplete="email"
            />
          </div>
          <div className="input-group">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-field"
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="login-button">
            Sign In →
          </button>
        </form>

        <p className="register-link">
          New to EmoNews? <a href="/register">Create an account</a>
        </p>

        <div className="branding-footer">
          <span className="author-tag">BY JOFRA</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
